export const CAR_LIST_CONTENT_PER_PAGE: number = 7;
export const WINNERS_LIST_CONTENT_PER_PAGE: number = 10;